var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pa-md-8",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_vm._v(" Ga naar terug naar "),_c('router-link',{attrs:{"router":"","to":{ name: 'home'}}},[_vm._v("homepage")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }